"use client";
import "./index.es16.js";
import "react";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import r from "./index.es65.js";
r.fieldset`
  display: flex;
  & > * {
    margin-right: 0.5rem;
    margin-top: 0.25rem;
    margin-bottom: 0.75rem;
  }

  legend {
    border: none;
  }
`;
//# sourceMappingURL=index.es32.js.map
